import { authAvatarUrl } from './AuthStore';

export const updateAuthAvatarUrl = (value) => authAvatarUrl.update((oldValue) => value);
